<template>
  <div class="permissions-form">
    <div class="type-options">
      <label
        v-for="type in userTypes"
        :key="type.key"
        class="type-card"
        :class="{ 'is-selected': userType === type.key }"
      >
        <input
          type="radio"
          :name="groupName"
          :checked="userType === type.key"
          @change="onTypeChange(type.key)"
        />
        <b>{{ type.label }}</b>
        <span>{{ type.description }}</span>
      </label>
    </div>

    <p v-if="claims.admin" class="admin-note">
      Con tipo Admin no se asignan permisos por módulo.
    </p>

    <div v-else>
      <div v-for="group in visibleModules" :key="group.title" class="module-row">
        <div>
          <div class="module-name">{{ group.title }}</div>
          <div class="module-desc">{{ group.description }}</div>
        </div>
        <div class="pills">
          <label v-for="item in group.items" :key="item.key" class="pill">
            <input
              type="checkbox"
              :checked="claims[item.key] === true"
              @change="onToggle(item.key, $event.target.checked)"
            />
            <span>{{ item.label }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PERMISSION_GROUPS } from "../helpers";

let uid = 0;

export default {
  name: "PermissionsForm",
  props: {
    claims: {
      type: Object,
      required: true,
    },
  },
  data() {
    uid += 1;
    return {
      groupName: `user-type-${uid}`,
    };
  },
  computed: {
    userTypes() {
      return PERMISSION_GROUPS.userTypes;
    },
    userType() {
      if (this.claims.admin) return "admin";
      if (this.claims.cliente) return "cliente";
      return null;
    },
    visibleModules() {
      return PERMISSION_GROUPS.modules.filter(
        (group) => !group.requiresCliente || this.claims.cliente,
      );
    },
  },
  methods: {
    onTypeChange(type) {
      if (type === "admin") {
        this.$emit("toggle", "admin", true);
        return;
      }
      if (Object.prototype.hasOwnProperty.call(this.claims, "admin")) {
        this.$emit("toggle", "admin", false);
      }
      this.$emit("toggle", "cliente", true);
    },
    onToggle(key, value) {
      this.$emit("toggle", key, value === true);
    },
  },
};
</script>

<style scoped>
.type-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.type-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 14px 12px 42px;
  border: 1px solid #dbdbdb;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.type-card input {
  position: absolute;
  top: 15px;
  left: 14px;
  width: 17px;
  height: 17px;
  accent-color: #510087;
}

.type-card.is-selected {
  border-color: #7957d5;
  background: #f7f4fb;
}

.type-card b {
  font-size: 14px;
  font-weight: 600;
  color: #363636;
}

.type-card span {
  font-size: 13px;
  color: #7a7a7a;
}

.module-row {
  display: grid;
  grid-template-columns: 190px 1fr;
  gap: 8px 16px;
  align-items: center;
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
}

.module-name {
  font-size: 14px;
  font-weight: 600;
  color: #363636;
}

.module-desc {
  font-size: 12px;
  color: #7a7a7a;
}

.pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.pill {
  position: relative;
  cursor: pointer;
}

.pill input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.pill span {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 34px;
  padding: 0 14px;
  border: 1px solid #dbdbdb;
  border-radius: 17px;
  background: #fff;
  font-size: 14px;
  color: #363636;
}

.pill span::before {
  content: "";
  width: 14px;
  height: 14px;
  border: 1.5px solid #b5b5b5;
  border-radius: 50%;
}

.pill input:checked + span {
  border-color: #7957d5;
  background: #f7f4fb;
  color: #510087;
  font-weight: 600;
}

.pill input:checked + span::before {
  border-color: #510087;
  background: #510087;
  box-shadow: inset 0 0 0 3px #f7f4fb;
}

.pill input:focus-visible + span {
  outline: 2px solid #7957d5;
  outline-offset: 1px;
}

.admin-note {
  margin: 16px 0 0;
  padding-top: 14px;
  border-top: 1px solid #f0f0f0;
  font-size: 13px;
  color: #7a7a7a;
}

@media (max-width: 560px) {
  .module-row {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/components/PermissionsForm.vue